<template>
	<div>
		<div v-for="(o, idx) in item" :key="idx">
			<div v-if="!o.children || o.noAuthCode">
				<el-menu-item :index="o.meta.key" :route="{ path: o.path }">
					<template>
						<i :class="o.meta.icon || getRandomIcon(idx)" v-if="o.meta.icon || true"></i>
						<span>{{ o.meta.title }}</span>
					</template>
				</el-menu-item>
			</div>
			<div v-else>
				<el-submenu :index="o.meta.key">
					<template slot="title">
						<i :class="o.meta.icon || getRandomIcon(idx)" v-if="o.meta.icon || true"></i>
						<span>{{ o.meta.title }}</span>
					</template>
					<MenuItem :item="o.children"></MenuItem>
				</el-submenu>
			</div>
		</div>
	</div>
</template>
<script>
	// 递归组件menu 通过递归显示需要的菜单
	export default {
		name: "MenuItem",
		data() {
			return {
				clicked: false,
				iconList: [
					'el-icon-s-home',
					'el-icon-s-order',
					'el-icon-s-custom',
					'el-icon-s-tools',
					'el-icon-s-data',
					'el-icon-s-check',
					'el-icon-s-claim',
					'el-icon-s-finance',
					'el-icon-s-shop',
					'el-icon-s-marketing',
					'el-icon-s-flag',
					'el-icon-s-promotion',
					'el-icon-s-comment',
					'el-icon-s-operation',
					'el-icon-s-platform',
					'el-icon-s-management',
					'el-icon-s-release',
					'el-icon-s-ticket',
					'el-icon-s-open',
					'el-icon-s-goods',
					'el-icon-s-help',
					'el-icon-s-cooperation',
					'el-icon-document',
					'el-icon-folder',
					'el-icon-setting',
					'el-icon-user',
					'el-icon-user-solid',
					'el-icon-office-building',
					'el-icon-suitcase',
					'el-icon-notebook-2',
					'el-icon-first-aid-kit',
					'el-icon-umbrella',
					'el-icon-shopping-cart-full',
					'el-icon-wallet',
					'el-icon-bank-card',
					'el-icon-tickets',
					'el-icon-collection',
					'el-icon-reading',
					'el-icon-data-line',
					'el-icon-pie-chart',
					'el-icon-monitor',
					'el-icon-edit',
					'el-icon-document-copy',
					'el-icon-printer',
					'el-icon-message',
					'el-icon-chat-dot-round',
					'el-icon-phone',
					'el-icon-video-camera',
					'el-icon-camera',
					'el-icon-mic',
					'el-icon-bell',
					'el-icon-alarm-clock',
					'el-icon-timer',
					'el-icon-date',
					'el-icon-search',
					'el-icon-view',
					'el-icon-more',
					'el-icon-star-on',
					'el-icon-star-off',
					'el-icon-sunny',
					'el-icon-cloudy',
					'el-icon-lightning',
					'el-icon-heavy-rain',
					'el-icon-moon',
					'el-icon-sunrise',
					'el-icon-sunset',
					'el-icon-truck',
					'el-icon-box',
					'el-icon-present',
					'el-icon-coin',
					'el-icon-money',
					'el-icon-bank-card',
					'el-icon-goods',
					'el-icon-sell',
					'el-icon-sold-out',
					'el-icon-shopping-bag-1',
					'el-icon-shopping-bag-2',
					'el-icon-shopping-cart-1',
					'el-icon-shopping-cart-2',
					'el-icon-files',
					'el-icon-folder-checked',
					'el-icon-folder-delete',
					'el-icon-folder-opened',
					'el-icon-document-add',
					'el-icon-document-checked',
					'el-icon-document-delete',
					'el-icon-document-remove',
					'el-icon-tickets',
					'el-icon-collection-tag',
					'el-icon-data-board',
					'el-icon-data-analysis',
					'el-icon-copy-document',
					'el-icon-full-screen',
					'el-icon-switch-button',
					'el-icon-refresh',
					'el-icon-refresh-right',
					'el-icon-refresh-left',
					'el-icon-download',
					'el-icon-upload',
					'el-icon-top',
					'el-icon-bottom',
					'el-icon-left',
					'el-icon-right',
					'el-icon-top-right',
					'el-icon-top-left',
					'el-icon-bottom-right',
					'el-icon-bottom-left',
					'el-icon-arrow-up',
					'el-icon-arrow-down',
					'el-icon-arrow-left',
					'el-icon-arrow-right',
					'el-icon-d-arrow-left',
					'el-icon-d-arrow-right',
					'el-icon-menu',
					'el-icon-s-grid',
					'el-icon-grid',
					'el-icon-s-unfold',
					'el-icon-s-fold',
					'el-icon-question',
					'el-icon-info',
					'el-icon-warning',
					'el-icon-circle-close',
					'el-icon-circle-check',
					'el-icon-success',
					'el-icon-error',
					'el-icon-remove',
					'el-icon-circle-plus',
					'el-icon-plus',
					'el-icon-minus',
					'el-icon-zoom-in',
					'el-icon-zoom-out',
					'el-icon-rank',
					'el-icon-sort',
					'el-icon-sort-up',
					'el-icon-sort-down',
					'el-icon-d-caret',
					'el-icon-caret-top',
					'el-icon-caret-bottom',
					'el-icon-caret-left',
					'el-icon-caret-right',
					'el-icon-finished',
					'el-icon-refresh',
					'el-icon-loading',
					'el-icon-link',
					'el-icon-connection',
					'el-icon-set-up',
					'el-icon-set',
					'el-icon-turn-off',
					'el-icon-open',
					'el-icon-magic-stick',
					'el-icon-brush',
					'el-icon-picture',
					'el-icon-picture-outline',
					'el-icon-picture-outline-round',
					'el-icon-upload2',
					'el-icon-download2',
					'el-icon-camera-solid',
					'el-icon-video-camera-solid',
					'el-icon-message-solid',
					'el-icon-chat-dot-square',
					'el-icon-chat-line-square',
					'el-icon-chat-round',
					'el-icon-chat-line-round',
					'el-icon-chat-square',
					'el-icon-phone-outline',
					'el-icon-mobile-phone',
					'el-icon-tablet',
					'el-icon-news',
					'el-icon-guide',
					'el-icon-attract',
					'el-icon-thumb',
					'el-icon-pointer',
					'el-icon-mouse',
					'el-icon-coordinate',
					'el-icon-magnet',
					'el-icon-odometer',
					'el-icon-cpu',
					'el-icon-watch',
					'el-icon-stopwatch',
					'el-icon-map-location',
					'el-icon-delete-location',
					'el-icon-add-location',
					'el-icon-location-outline',
					'el-icon-location-information',
					'el-icon-discover',
					'el-icon-first-aid-kit',
					'el-icon-trophy',
					'el-icon-trophy-1',
					'el-icon-medal',
					'el-icon-medal-1',
					'el-icon-stopwatch',
					'el-icon-baseball',
					'el-icon-soccer',
					'el-icon-football',
					'el-icon-basketball',
					'el-icon-ship',
					'el-icon-truck',
					'el-icon-bicycle',
					'el-icon-mobile',
					'el-icon-service',
					'el-icon-key',
					'el-icon-unlock',
					'el-icon-lock',
					'el-icon-dish',
					'el-icon-dish-1',
					'el-icon-food',
					'el-icon-chicken',
					'el-icon-fork-spoon',
					'el-icon-knife-fork',
					'el-icon-burger',
					'el-icon-tableware',
					'el-icon-sugar',
					'el-icon-dessert',
					'el-icon-ice-cream',
					'el-icon-hot-water',
					'el-icon-goblet',
					'el-icon-goblet-full',
					'el-icon-goblet-square',
					'el-icon-goblet-square-full',
					'el-icon-refrigerator',
					'el-icon-grape',
					'el-icon-watermelon',
					'el-icon-cherry',
					'el-icon-apple',
					'el-icon-pear',
					'el-icon-orange',
					'el-icon-coffee',
					'el-icon-ice-tea',
					'el-icon-ice-drink',
					'el-icon-milk-tea',
					'el-icon-potato-strips',
					'el-icon-lollipop',
					'el-icon-ice-cream-square',
					'el-icon-ice-cream-round',
				]
			};
		},
		props: {
			item: {
				type: Array,
				default: () => {
					return [];
				},
			},
		},
		methods: {
			start() {
				return this.item;
			},
			getRandomIcon(index) {
				// 根据索引和菜单标题生成固定的图标，保证每次渲染一致
				const iconIndex = index % this.iconList.length;
				return this.iconList[iconIndex];
			}
		},
	};
</script>

<style lang="scss" scoped>
::v-deep .el-menu-item i,
::v-deep .el-submenu__title i {
	margin-right: 8px;
	font-size: 16px;
	width: 20px;
	text-align: center;
}
</style>
